
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sources/mixpanel",
      function () {
        return require("private-next-pages/sources/mixpanel.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sources/mixpanel"])
      });
    }
  